export const environment = {
    production: false,
    //for organonDev
    idmUrl: 'https://javelin.zsservices.com/Organon/IdentityManager/app/Web/Login.aspx?ReturnUrl=https://cds-organon.zsservices.com/projects',
    organization: 'ORGANON',
    accessRequestUrl : '',
    mailDl :''
  
  };
